import { OnlyInstantiableByContainer, Singleton } from "typescript-ioc";
import { IMultipleCouriersAddressModel } from "./IMultipleCouriersAddressModel";
import { HomeDeliveryAddressKey } from "./HomeDeliveryAddressKey";

@OnlyInstantiableByContainer
@Singleton
export class DeliveryChannelsHelper {
    public prepareCouriersData(
        homeDeliveryAddresses: IAddress[],
        homeDeliveryChannels: IChannelsInfo[],
        addressKey: HomeDeliveryAddressKey = HomeDeliveryAddressKey.HomeDeliveryAddresses
    ): IMultipleCouriersAddressModel[] {
        const allAddresses = this.getAllAddresses(homeDeliveryAddresses, null, addressKey);
        const couriersAddresses: IMultipleCouriersAddressModel[] = [];

        const channelMap = new Map<number, IChannelsInfo>(
            homeDeliveryChannels.map((deliveryChannel) => [
                deliveryChannel.DeliveryChannelId,
                deliveryChannel,
            ]) as []
        );

        for (const address of allAddresses) {
            const channels = new Map<number, IChannelAddressInfo>(
                address.HomeDeliveryChannelsInfo.map((deliveryChannel) => [
                    deliveryChannel.Id,
                    deliveryChannel,
                ]) as []
            );

            const availableChannels: IChannelAddressInfo[] = [];
            channels.forEach((channel) => {
                if (channel.IsAllowed) {
                    availableChannels.push(channel);
                }
            });

            const newChannels: IChannelsInfo[] = [];
            availableChannels.forEach((channel) => {
                const newChannel: IChannelsInfo | undefined = channelMap.get(channel.Id);
                if (newChannel) {
                    newChannels.push(newChannel);
                }
            });

            address.isAllowed = newChannels.filter((channel) => channel.IsAllowed).length > 0;

            let outOfStockItems: IOutOfStockItems[] = [];

            if (address.isAllowed) {
                const firstAllowedChannel = newChannels.find((channel) => channel.IsAllowed);
                if (firstAllowedChannel) {
                    outOfStockItems = firstAllowedChannel.OutOfStockItems;
                }
            }

            const courierHomeDeliveryAddress: IMultipleCouriersAddressModel = {
                ...address,
                HomeDeliveryChannels: newChannels,
                OutOfStockItems: outOfStockItems,
            };

            couriersAddresses.push(courierHomeDeliveryAddress);
        }
        return couriersAddresses;
    }

    public getAllAddresses(
        HomeDeliveryAddresses: IAddress[],
        channel: IChannelsInfo | null = null,
        addressKey: HomeDeliveryAddressKey = HomeDeliveryAddressKey.HomeDeliveryAddresses
    ): IAddress[] {
        return HomeDeliveryAddresses.map((address, index) => ({
            ...address,
            isAllowed: channel ? channel[addressKey][index].IsAllowed : true,
        }));
    }
}
